@if (railMenu; as entries) {
  <app-rail-menu
    [entries]="entries"
    [submenus]="{ 'new-item': newEventForm, 'new-container': newCalendarForm }"
    (selected)="runRailEntry($event)"
  />
  <ng-template #newEventForm>
    <app-event-quick-form class="quick-form" [event]="railNewEvent" [destinationTenantId]="railDestinationTenantId" [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true" (close)="handleClose()" (more)="handleQuickDetails($event)" />
  </ng-template>
  <ng-template #newCalendarForm>
    <app-calendar-quick-form #railCalendarForm class="quick-form" [creationTenantId]="tenantId" [calendar]="railNewCalendar" [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true" (save)="createCalendar($event, railCalendarForm)" (close)="handleClose()" (more)="handleQuickDetails($event)" />
  </ng-template>
} @else {
@if (!(['all_calendars', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="New event"
    >
    <app-event-quick-form
      class="quick-form"
      [event]="stitchItem"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
      />
    </app-context-menu-item>
  }

  @if (!(['all_events', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="New calendar"
      >
      <app-calendar-quick-form
        [creationTenantId]="tenantId"
        #calendarForm
        class="quick-form"
        [calendar]="containerStitchItem"
        (save)="createCalendar($event, calendarForm)"
        [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
        (close)="handleClose()"
        (more)="handleQuickDetails($event)" />
      </app-context-menu-item>
    }

    @if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if ((['flagged', 'snoozed', 'followed'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <app-context-menu-item
        title="Empty trash"
        [disabled]="!(tenantId | appCanPurgeTeamItem)"
        [note]="PURGE_REFUSED_REASON"
        [matTooltip]="(tenantId | appCanPurgeTeamItem) ? '' : PURGE_REFUSED_REASON"
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (rail) {
      <app-context-menu-item title="View settings…" [close]="true" (execute)="openRowViewSettings()" />
    } @else if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-item
        title="Settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }
}
